import EntryPoint from '../../../EntryPoint';
import GlobalDispatcher from '../../../events/GlobalDispatcher';
import SoundManager from '../../../soundManager/SoundManager';
import StatesManager from '../../../base/states/StatesManager';
import eStateTypes from '../../../enums/eBaseStateTypes';
import eEventTypes from '../../../enums/eBaseEventTypes';

export default class BaseUiAdapter {
  constructor(ControllerUi) {
    EntryPoint.PlayerUiAdapter = this;
    this._controllerUi = ControllerUi;
    this._currentOrientation = this._controllerUi.currentOrientation;
    this._uiVisible = true;

    this._onAutoPlayChange = this._onAutoPlayChange.bind(this);

    this.initStateHandlers();
    this.initExtraStateHandlers();
    this.addListeners();
  }

  init(config) {
    this._initConfig = config || this._initConfig;
    this._bonusLabelText = this._initConfig.bonusLabelText;
    this._buttonClickSound = this._initConfig.clickSound;

    this.ControllerUi.setAvailableBets(EntryPoint.GameModel.betPossible);
    this.ControllerUi.setCurrentBetIndex(EntryPoint.GameModel.betIndex);
    this.ControllerUi.setBalance(EntryPoint.GameModel.balance);
    this.ControllerUi.setLastWin(EntryPoint.GameModel.lastWin);
    this.ControllerUi.setWin(EntryPoint.GameModel.totalWin);

    window.OPWrapperService.autoPlay.quickPlay = EntryPoint.GameSettings.quickSpin;

    let soundMuted = Boolean(EntryPoint.GameSettings.musicMute) && Boolean(EntryPoint.GameSettings.soundMute) && Boolean(EntryPoint.GameSettings.winningMute);
    this.ControllerUi.setSoundMuted(soundMuted);

    if (EntryPoint.GameModel.freespinsEnabled) {
      this.ControllerUi.showFreeSpins(EntryPoint.GameModel.freespins);
      this.ControllerUi.showTotalWin(EntryPoint.GameModel.freespinsTotalWin);
    }

    this.baseOnStateChanged({ params: StatesManager.currentState.stateData.name });

    if (this._uiVisible) {
      this.showUi();
    } else {
      this.hideUi();
    }

    this.addActions();
  }

  addActions() {
    const controllerTypes = this.ControllerUi.controllerTypes;
    const events = this.ControllerUi.events;

    if (events[controllerTypes.ECT_BET_SELECTOR_TABLE]) {
      this.ControllerUi.on(events[controllerTypes.ECT_BET_SELECTOR_TABLE].CHANGE_BET_CLICK, this.onChangeBetClick.bind(this));
      this.ControllerUi.on(events[controllerTypes.ECT_BET_SELECTOR_TABLE].CLOSE_CLICK, this.playClickSound.bind(this));
    }
    if (events[controllerTypes.ECT_BET_SELECT]) {
      this.ControllerUi.on(events[controllerTypes.ECT_BET_SELECT].SHOW_BETS_CLICK, this.playClickSound.bind(this));
      this.ControllerUi.on(events[controllerTypes.ECT_BET_SELECT].HIDE_BETS_CLICK, this.playClickSound.bind(this));
    }
    if (events[controllerTypes.ECT_SPIN]) {
      this.ControllerUi.on(events[controllerTypes.ECT_SPIN].SPIN_CLICK, this.onSpinClick.bind(this));
    }
    if (events[controllerTypes.ECT_AUTO_SPIN]) {
      this.ControllerUi.on(events[controllerTypes.ECT_AUTO_SPIN].AUTO_SPIN_CLICK, this.onAutoPlayClick.bind(this));
    }

    if (events[controllerTypes.ECT_AUTO_PLAY_TABLE]) {
      this.ControllerUi.on(events[controllerTypes.ECT_AUTO_PLAY_TABLE].START_AUTO_SPINS_CLICK, this.onStartAutoPlayClick.bind(this));
      this.ControllerUi.on(events[controllerTypes.ECT_AUTO_PLAY_TABLE].CLOSE_CLICK, this.playClickSound.bind(this));
    }
    if (events[controllerTypes.ECT_TURBO_SPIN]) {
      this.ControllerUi.on(events[controllerTypes.ECT_TURBO_SPIN].TURBO_SPIN_CLICK, this.onTurboPlayClick.bind(this));
    }
    if (events[controllerTypes.ECT_MENU]) {
      this.ControllerUi.on(events[controllerTypes.ECT_MENU].BURGER_CLICK, this.onMenuClick.bind(this));
    }
    if (events[controllerTypes.ECT_SOUND]) {
      this.ControllerUi.on(events[controllerTypes.ECT_SOUND].SOUND_MUTE_CLICK, this.onSoundClick.bind(this));
      this.ControllerUi.on(events[controllerTypes.ECT_SOUND].SOUND_UNMUTE_CLICK, this.onSoundClick.bind(this));
    }
    if (events[controllerTypes.ECT_INFO]) {
      this.ControllerUi.on(events[controllerTypes.ECT_INFO].INFO_CLICK, this.onPaytableClick.bind(this));
    }
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EBET_STATE_MANAGER__STATE_CHANGED, this.baseOnStateChanged, this);
    GlobalDispatcher.add(eEventTypes.EBET_BET_CHANGED, this.syncBet, this);
    GlobalDispatcher.add(eEventTypes.EBET_AVAILABLE_BETS_CHANGED, this.syncAvailableBets, this);
    GlobalDispatcher.add(eEventTypes.EBET_SETTINGS__SOUND_MUTE, this.updateSoundMuted, this);
    GlobalDispatcher.add(eEventTypes.EBET_SETTINGS__MUSIC_MUTE, this.updateSoundMuted, this);
    GlobalDispatcher.add(eEventTypes.EBET_SETTINGS__WINNING_MUTE, this.updateSoundMuted, this);
    GlobalDispatcher.add(eEventTypes.EBET_BIG_WIN_ANIMATION_VISIBLE_CHANGE, this.onBigWinsVisibilityChange, this);
    GlobalDispatcher.add(eEventTypes.EBET_PAYTABLE__BACK_CLICK, this.showUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_FREESPIN_IN_STATE__END, this.showUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_FREESPIN_OUT_STATE__END, this.showUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_PURCHASE__CLOSE, this.showUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_PURCHASE_BTN_CLICK, this.hideUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_SHOW_USER_INTERFACE, this.showUi, this);
    GlobalDispatcher.add(eEventTypes.EBET_HIDE_USER_INTERFACE, this.hideUi, this);
    if (!OPWrapperService.config.disableSpinBySpace) window.addEventListener('keydown', this.onKeyDown.bind(this));
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
    OPWrapperService.autoPlay.onChange.add(this._onAutoPlayChange)
  }

  setWinValue(value) {
    this.ControllerUi.setWinValue(value);
  }

  setBalanceValue(value) {
    this.ControllerUi.setBalance(value);
  }

  onGameResized(data) {
    if (EntryPoint.mobile) {
      if (this._controllerUi.currentOrientation === this._currentOrientation) return;
      this._currentOrientation = this._controllerUi.currentOrientation;
      this.init();
    }
  }

  onKeyDown(event) {
    if (event.keyCode === 32 && this._uiVisible) {
      if (this.ControllerUi.spinButtonEnabled) {
        return this.onSpinClick();
      }
    }
  }

  showUi() {
    this._uiVisible = true;
    this.ControllerUi.show();
  }

  hideUi() {
    this._uiVisible = false;
    this.ControllerUi.hide();
  }

  onBigWinsVisibilityChange({ params: visible }) {
    if (visible) {
      if (EntryPoint.AutoPlaySettings.active) {
        this.ControllerUi.setOpacity(0.5);
      } else {
        this.hideUi();
      }
    } else {
      this.ControllerUi.setOpacity(1);
      this.showUi();
    }
  }

  syncBet() {
    if (this._currentState === eStateTypes.EBST_IDLE) {
      this.ControllerUi.setCurrentBetIndex(EntryPoint.GameModel.betIndex);
    }
  }

  syncAvailableBets() {
    if (this._currentState === eStateTypes.EBST_IDLE) {
      this.ControllerUi.setAvailableBets(EntryPoint.GameModel.betPossible);
    }
  }

  updateBalance(value) {
    if (value === undefined) value = EntryPoint.GameModel.balance;
    this.ControllerUi.setBalance(value);
  }

  updateSoundMuted() {
    let soundMuted = Boolean(EntryPoint.GameSettings.musicMute) && Boolean(EntryPoint.GameSettings.soundMute) && Boolean(EntryPoint.GameSettings.winningMute);
    this.ControllerUi.setSoundMuted(soundMuted);
  }


  onSoundClick(muted) {
    EntryPoint.GameSettings.soundMute = muted;
    EntryPoint.GameSettings.winningMute = muted;
    EntryPoint.GameSettings.musicMute = muted;
  }

  onAutoPlayClick() {
    this.playClickSound();
  }

  onStartAutoPlayClick() {
    this.playClickSound();
    this.onSpinClick();
  }

  onTurboPlayClick() {
    this.playClickSound();
    window.OPWrapperService.autoPlay.quickPlay = !window.OPWrapperService.autoPlay.quickPlay;
  }

  onStopClick() {
    console.warn('Method deprecated');
  }

  onSpinClick() {
    if (window.OPWrapperService.model.data.isSpinBlocked) return;

    this.ControllerUi.toggleSpinButton(false);
    this.playClickSound();
    if (StatesManager.currentState.stateData.name === eStateTypes.EBST_IDLE &&
      EntryPoint.GameModel.bet > EntryPoint.GameModel.balance &&
      !EntryPoint.GameModel.isSpinWithoutBalanceCheck
    ) {
      this.ControllerUi.toggleSpinButton(true);
      this.ControllerUi.hideAutoPlayTable()
      window.OPWrapperService.autoPlay.active = false;
      window.OPWrapperService.showError(window.OPWrapperService.errors.INSUFFICIENT_BALANCE_CLIENT.CODE);
      return
    }

    if (window.OPWrapperService.sideBarVisible) {
      window.OPWrapperService.sideBar.hide();
    }
    GlobalDispatcher.dispatch(eEventTypes.EBET_SPIN_CLICK);
  }

  onChangeBetClick(index) {
    this.playClickSound();
    GlobalDispatcher.dispatch(eEventTypes.EBET_UI_CHANGE_BET, index);
  }

  onMenuClick() {
    this.playClickSound();
    window.OPWrapperService.toggleSidebar();
  }

  onPaytableClick() {
    this.playClickSound();
    GlobalDispatcher.dispatch(eEventTypes.EBET_PAYTABLE__CLICK);
    this.hideUi();
  }

  playClickSound() {
    if (this._buttonClickSound) {
      SoundManager.play(this._buttonClickSound.soundName, this._buttonClickSound.volume, false, this._buttonClickSound.group);
    }
  }

  baseOnStateChanged(event) {
    this.onStateChanged(event);
    this.ControllerUi.showSpinButton();
    if (OPWrapperService.config.skipBlocked && !EntryPoint.AutoPlaySettings.active && !this.statesCanTriggerSpin.includes(event.params)) {
      this.ControllerUi.toggleSpinButton(false);
    }
  }

  _onAutoPlayChange() {
    EntryPoint.AutoPlaySettings.setActive(OPWrapperService.autoPlay.active);
    EntryPoint.GameSettings.quickSpin = window.OPWrapperService.autoPlay.quickPlay;
    this.ControllerUi.setTurboPlayButtonActive(window.OPWrapperService.autoPlay.quickPlay);
    if (!OPWrapperService.autoPlay.active) {
      this.ControllerUi.hideAutoPlayCount();
      this.ControllerUi.toggleAutoPlayButton(this.statesCanTriggerSpin.includes(StatesManager.currentState.stateData.name) && this.isAutoPlayButtonCanBeEnabled);
    }
  }

  onStateChanged(event) {
    const state = event.params;
    this._currentState = state;

    if (this.stateHandlers.hasOwnProperty(state)) {
      this.stateHandlers[state]();
    } else {
      this.stateHandlers.default();
    }

    if (this.extraStateHandlers.hasOwnProperty(state)) {
      this.extraStateHandlers[state]();
    } else {
      this.extraStateHandlers.default();
    }

    this.handleExtras();
  }

  initStateHandlers() {
    this.stateHandlers = {
      [eStateTypes.EBST_WAIT_USER_INTERACTION]: () => {
        this.ControllerUi.showFreeSpins(EntryPoint.GameModel.freespins, this._bonusLabelText);
        this.ControllerUi.toggleSpinButton(true);

        this.ControllerUi.toggleAutoPlayButton(this.isAutoPlayButtonCanBeEnabled);
        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleMenuButton(true);
        this.ControllerUi.toggleInfoButton(true);

        this.ControllerUi.setBalance(EntryPoint.GameModel.balance);
        if (EntryPoint.GameModel.freespinsTotalWin) this.ControllerUi.showTotalWin(EntryPoint.GameModel.freespinsTotalWin);
        this.ControllerUi.toggleTournamentsLabel(true);
      },
      [eStateTypes.EBST_IDLE]: () => {
        this.syncAvailableBets();
        this.syncBet();
        this.ControllerUi.toggleSpinButton(!EntryPoint.AutoPlaySettings.active && !this.isBonusGameEnabled);

        this.ControllerUi.toggleAutoPlayButton(this.isAutoPlayButtonCanBeEnabled || EntryPoint.AutoPlaySettings.active);
        this.ControllerUi.toggleMenuButton(!EntryPoint.AutoPlaySettings.active && !this.isBonusGameEnabled);
        this.ControllerUi.toggleInfoButton(!EntryPoint.AutoPlaySettings.active && !this.isBonusGameEnabled);
        this.ControllerUi.toggleBetSelectors(!EntryPoint.AutoPlaySettings.active && !this.isBonusGameEnabled);
        this.ControllerUi.toggleTournamentsLabel(!EntryPoint.AutoPlaySettings.active && !this.isBonusGameEnabled);
        this.ControllerUi.setBalance(EntryPoint.GameModel.balance);

        if (EntryPoint.GameModel.freespinsEnabled) {
          this.ControllerUi.setTotalWin(EntryPoint.GameModel.freespinsTotalWin);
          this.ControllerUi.setFreeSpinsCount(EntryPoint.GameModel.freespins);
        }
      },
      [eStateTypes.EBST_REQUEST_ROLLING]: () => {
        this.ControllerUi.closePopups();
        this.ControllerUi.runSpinAnimation();

        if (!this.isBonusGameEnabled && window.OPWrapperService.autoPlay.active) this.ControllerUi.showAutoPlayCount();
        this.ControllerUi.toggleSpinButton(!OPWrapperService.config.roundDuration && !EntryPoint.GameSettings.quickSpin);

        this.ControllerUi.toggleAutoPlayButton(EntryPoint.AutoPlaySettings.active);
        this.ControllerUi.toggleMenuButton(false);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleTournamentsLabel(false);
        this.ControllerUi.setWin(0);
        this.ControllerUi.hideWinLine();
        const { balance } = EntryPoint.GameModel;

        this.ControllerUi.setBalance(balance);

        if (EntryPoint.GameModel.freespinsEnabled) {
          this.ControllerUi.setFreeSpinsCount(EntryPoint.GameModel.freespins - 1);
        } else {
          this.ControllerUi.hideFreeSpinsLabel();
        }
      },
      [eStateTypes.EBST_MINIMAL_ROLLING]: () => {
        this.ControllerUi.toggleSpinButton(!OPWrapperService.config.roundDuration && !EntryPoint.GameSettings.quickSpin);

        this.ControllerUi.toggleAutoPlayButton(EntryPoint.AutoPlaySettings.active);
        this.ControllerUi.toggleMenuButton(false);

        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleTournamentsLabel(false);
      },
      [eStateTypes.EBST_STOP_ROLLING]: () => {
        this.ControllerUi.toggleSpinButton(false);

        this.ControllerUi.toggleAutoPlayButton(EntryPoint.AutoPlaySettings.active);
        this.ControllerUi.toggleMenuButton(false);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleTournamentsLabel(false);
        this.ControllerUi.toggleBetSelectors(false);
      },
      [eStateTypes.EBST_FREE_SPINS_IN]: () => {
        this.hideUi();
        this.ControllerUi.toggleSpinButton(false);

        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.setBalance(EntryPoint.GameModel.balance);
        this.ControllerUi.showFreeSpins(EntryPoint.GameModel.freespins);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleTournamentsLabel(false);
        this.ControllerUi.showTotalWin(EntryPoint.GameModel.freespinsTotalWin)
      },
      [eStateTypes.EBST_FREE_SPINS_OUT]: () => {
        this.hideUi();
        this.ControllerUi.toggleSpinButton(false);

        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleTournamentsLabel(false);
        this.ControllerUi.setTotalWin(EntryPoint.GameModel.freespinsTotalWin);
        this.ControllerUi.hideFreeSpins();
        this.ControllerUi.hideTotalWin();
      },
      [eStateTypes.EBST_SHOW_WIN]: () => {
        this.ControllerUi.toggleSpinButton(true);

        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleTournamentsLabel(false);
      },
      [eStateTypes.EBST_STOP_WIN]: () => {
        this.ControllerUi.toggleSpinButton(false);
        this.ControllerUi.setWin(EntryPoint.GameModel.totalWin);
      },
      default: () => {
        this.ControllerUi.toggleSpinButton(false);
        this.ControllerUi.toggleAutoPlayButton(EntryPoint.AutoPlaySettings.active);
        this.ControllerUi.toggleMenuButton(false);
        this.ControllerUi.toggleBetSelectors(false);
        this.ControllerUi.toggleInfoButton(false);
        this.ControllerUi.toggleTournamentsLabel(false);
      },
    };
  }

  initExtraStateHandlers() {
    if (!this.extraStateHandlers) {
      this.extraStateHandlers = {
        default: () => {
        }
      };
    }
  }

  handleExtras() {
    if (EntryPoint.AutoPlaySettings.active && this.isAutoPlayButtonCanBeEnabled) {
      this.ControllerUi.toggleAutoPlayButton(true);
      this.ControllerUi.toggleBetSelectors(false);
    }

    if (OPWrapperService.freeBetsController.isActive) {
      this.ControllerUi.toggleBetSelectors(false);
    }
  }

  get isAutoPlayButtonCanBeEnabled() {
    return !this.isBonusGameEnabled;
  }

  get statesCanTriggerSpin() {
    return [eStateTypes.EBST_IDLE, eStateTypes.EBST_WAIT_USER_INTERACTION];
  }

  get isBonusGameEnabled() {
    return EntryPoint.GameModel.freespinsEnabled;
  }

  get ControllerUi() {
    return this._controllerUi.hud;
  }
}
